export default "__VITE_ASSET__08437b08__"